// Pure helpers shared by the StudyPlanAdd and StudyPlanEdit cards.
//
// These were duplicated near-identically across the editor surface
// (see test-yted/src/lib/studyPlan/draft.js for the matching pair on
// the student app). Kept identical between the two apps so behaviour
// stays in lockstep until a shared @lf/study-plan-helpers package
// makes sense.

export function buildStudyPlanPayload(plan, lessons) {
  return {
    id: plan.id,
    version: plan.version,
    subject: plan.subject,
    goal: plan.goal,
    previous_knowledge: plan.previous_knowledge,
    needs: plan.needs,
    emoji: plan.emoji,
    num_lessons: parseInt(plan.num_lessons),
    lessons,
  };
}

export function cloneLessons(lessons) {
  return JSON.parse(JSON.stringify(lessons || []));
}

export function lessonInputsKey(plan) {
  return JSON.stringify({
    subject: plan.subject,
    goal: plan.goal,
    previous_knowledge: plan.previous_knowledge,
    needs: plan.needs,
  });
}
